import { useEffect, useState } from "react";
import { Search, X } from "lucide-react";
import { getAllCompanies } from "../../services/companiesService";
import { PageLoader } from "../loader/index";

// Componente reutilizable para búsqueda de socios
const SocioSearch = ({ onSocioSelect }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadCompanies = async () => {
      try {
        setLoading(true);
        const response = await getAllCompanies();
        setCompanies(response);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadCompanies();
  }, []);

  const filteredSocios = companies.filter((company) => {
    // Ocultar usuarios con rol admin
    if (company.role && company.role.toLowerCase() === "admin") return false;

    const term = searchTerm.toLowerCase();
    return (
      company.business_name.toLowerCase().includes(term) ||
      company.rut.includes(term) ||
      company.contact_email.toLowerCase().includes(term)
    );
  });

  const clearSearch = () => {
    setSearchTerm("");
    setIsDropdownOpen(false);
  };

  const handleSocioSelect = (company) => {
    onSocioSelect(company);
    setSearchTerm("");
    setIsDropdownOpen(false);
  };

  if (loading) return <PageLoader />;

  return (
    <div className="relative">
      <div className="relative mb-3">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
        <input
          type="text"
          placeholder="Buscar por nombre comercial, RUT o correo..."
          className="w-full pl-10 pr-10 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0488AF] focus:border-transparent text-black shadow-sm text-sm"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setIsDropdownOpen(e.target.value.length > 0);
          }}
          onFocus={() => searchTerm && setIsDropdownOpen(true)}
        />
        {searchTerm && (
          <button
            onClick={clearSearch}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={16} />
          </button>
        )}
      </div>

      {/* Dropdown de resultados */}
      {isDropdownOpen && filteredSocios.length > 0 && (
        <div className="absolute z-10 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto">
          {filteredSocios.map((company) => (
            <div
              key={company.rut}
              onClick={() => handleSocioSelect(company)}
              className="p-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0"
            >
              <div className="font-medium text-gray-900">{company.business_name}</div>
              <div className="text-sm text-gray-500">RUT: {company.rut}</div>
              <div className="text-sm text-gray-500">{company.contact_email}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SocioSearch;
